// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__e5fm1","shimmer":"styles_shimmer__eabpe"};